import { FlagIcon, LockIcon, ShieldIcon, CloudIcon } from '../components/Icons';

const points = [
  {
    icon: FlagIcon,
    title: 'One person, not a company',
    desc: 'Garage is an independent project built and run by one person in the United States. There is no growth target, no investor to answer to, and nobody else with a reason to look at your data.',
  },
  {
    icon: ShieldIcon,
    title: 'Your data is never sold',
    desc: 'Your vehicle data is never sold, shared or brokered. It is stored so that you can look at it, and for no other purpose.',
  },
  {
    icon: LockIcon,
    title: 'Locked behind passkeys',
    desc: 'Sign-in is a passkey bound to your device — there is no password to leak, phish or reuse. Commands sent to your car are signed before they leave.',
  },
  {
    icon: CloudIcon,
    title: 'Runs on one AWS account',
    desc: 'Everything — the API, the telemetry receiver and the database — runs in a single AWS account under my control, primarily in us-west-2. No analytics vendors, no third-party data brokers in the middle.',
  },
];

export default function Privacy(): JSX.Element {
  return (
    <section id="privacy" className="border-y border-border bg-surface/40 py-20 md:py-28">
      <div className="container-page">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow">Privacy &amp; trust</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">
            Private by design
          </h2>
          <p className="mt-4 text-lg text-muted">
            Garage exists to give Tesla owners their own data back — not to
            monetize it.
          </p>
        </div>
        <div className="mt-12 grid gap-4 sm:grid-cols-2">
          {points.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="card flex gap-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent/10 text-accent">
                <Icon className="h-6 w-6" />
              </div>
              <div>
                <h3 className="font-semibold">{title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
